import { LocaleEnum } from '@systemeio/ui-frontend'
import { useRouter } from 'next/router'
import FacebookLogoIcon from 'shared/icons/facebook-logo-icon'
import InstagramLogoIcon from 'shared/icons/instagram-logo-icon'
import LinkedinLogoIcon from 'shared/icons/linkedin-logo-icon'
import TwitterLogoIcon from 'shared/icons/twitter-logo-icon'
import YoutubeLogoIcon from 'shared/icons/youtube-logo-icon'
import {
  getFacebookLink,
  getInstagramLink,
  getLinkedinLink,
  getTwitterLink,
  getYoutubeLink,
} from '../utils/get-social-media-links'

export const SOCIAL_MEDIA_ICON_STYLES =
  'group-focus-visible:fill-brand-primary group-hover:fill-brand-primary main-transition-colors lg:scale-125'

export const SocialMediaWrapper = ({ href, children }: { href: string; children: JSX.Element }) => (
  <a
    target={'_blank'}
    rel={'noreferrer'}
    href={href}
    className={'group w-fit self-center outline-none'}
  >
    {children}
  </a>
)

const SocialMedia = () => {
  const router = useRouter()
  const locale = router.locale as LocaleEnum
  return (
    <div className={'col-span-4 flex grid-cols-5 justify-items-center gap-6 lg:grid'}>
      <SocialMediaWrapper href={getFacebookLink(locale)}>
        <FacebookLogoIcon className={SOCIAL_MEDIA_ICON_STYLES} />
      </SocialMediaWrapper>
      <SocialMediaWrapper href={getTwitterLink(locale)}>
        <TwitterLogoIcon className={SOCIAL_MEDIA_ICON_STYLES} />
      </SocialMediaWrapper>
      <SocialMediaWrapper href={getYoutubeLink(locale)}>
        <YoutubeLogoIcon className={SOCIAL_MEDIA_ICON_STYLES} />
      </SocialMediaWrapper>
      <SocialMediaWrapper href={getLinkedinLink(locale)}>
        <LinkedinLogoIcon className={SOCIAL_MEDIA_ICON_STYLES} />
      </SocialMediaWrapper>
      <SocialMediaWrapper href={getInstagramLink(locale)}>
        <InstagramLogoIcon className={SOCIAL_MEDIA_ICON_STYLES} />
      </SocialMediaWrapper>
    </div>
  )
}
export default SocialMedia
